import React, { Component } from "react";

import Api from "../../../../../lib/componentApi";
// TODO:buraya api düzenlendikten sonra dönüş yapılacak.
export default class AddAlsoAdded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1
    };
  }
  handleAddItem = () => {
    const { closeDefaultStatus, item, delivery, userAddressId } = this.props;
    const { quantity } = this.state;
    const data = {
      itemId: item.id,
      quantity,
      delivery,
      userAddressId,
      options: "",
      forceBasket: false
    };
    Api.post("/api/product/item/basket", data, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response.code);
      } else {
        if (response.status) {
          const newItem = item;
          closeDefaultStatus("addAlsoAdded", { newItem });
        }
      }
    });
  };
  handleItemCount = (event, type) => {
    event.preventDefault();
    const { quantity } = this.state;
    if (type === "dec") {
      this.setState({ quantity: quantity - 1 });
    } else {
      this.setState({ quantity: quantity + 1 });
    }
  };
  render() {
    const { closeDefaultStatus, item } = this.props;
    const { quantity } = this.state;
    return (
      <React.Fragment>
        {/* Header */}
        <div className="head-general with-back">
          <a href="javascript: void(0)" />
          <h4>{item.name}</h4>
          <a
            href="javascript: void(0)"
            onClick={() => closeDefaultStatus("addAlsoAdded")}
            className="close"
          >
            <icon className="icon icon-close" />
          </a>
        </div>
        {/* Header */}

        <div className="add-item-page">
          <div className="">
            <div className="white-bg add-item-form">
              <p>{item.description}</p>
              <div className="add-item-input">
                <button
                  disabled={quantity <= 1}
                  onClick={e => this.handleItemCount(e, "dec")}
                >
                  -
                </button>
                <span>{quantity}</span>
                <button onClick={e => this.handleItemCount(e, "inc")}>+</button>
              </div>
            </div>
            <div className="mt-1 btn-continue">
              <button className="btn btn-blue" onClick={this.handleAddItem}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
